import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export default withStyles(() => ({
  root: {
    margin: "8px 32px",
    color: "#06F",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  textSizeLarge: { padding: "4px 8px" },
}))(Button);
